import React from "react";
const ChevronLeft = (props) => (React.createElement("svg", Object.assign({ width: "32px", height: "57px", viewBox: "0 0 32 57" }, props, { xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { d: "M28.6 0c.9 0 1.9.4 2.6 1.1 1.4 1.4 1.4 3.7 0 5.2L8.9 28.6l22.3 22.3c1.4 1.4 1.4 3.7 0 5.2-1.4 1.4-3.7 1.4-5.2 0l-25-25c-1.4-1.4-1.4-3.7 0-5.2L25.9 1.1C26.6.4 27.6 0 28.6 0z" })));
export default ChevronLeft;
